(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marichyai-makers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mcy-makers-slider')) {
    customElements.define('mcy-makers-slider', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.mcy-feature-grid__items');
        this.button = this.querySelector('.mcy-makers-next');
        if (!this.rail || !this.button) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.update = () => {
          const mobile = matchMedia('(max-width: 749px)').matches;
          this.button.hidden = !mobile || this.rail.scrollWidth - this.rail.clientWidth - this.rail.scrollLeft <= 2;
          const media = this.rail.querySelector('.mcy-feature-card__media');
          if (mobile && media) this.style.setProperty('--makers-arrow-top', `${media.getBoundingClientRect().height / 2}px`);
        };
        this.rail.addEventListener('scroll', this.update, { passive: true, signal });
        this.button.addEventListener('click', () => {
          const card = this.rail.querySelector('.mcy-feature-card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          this.rail.scrollBy({ left: card.getBoundingClientRect().width + gap, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcy-recently-viewed"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mcy-recent-products')){
customElements.define('mcy-recent-products',class extends HTMLElement{
  connectedCallback(){
    this.onConsent=()=>this.start();
    document.addEventListener('visitorConsentCollected',this.onConsent);
    if(window.Shopify?.customerPrivacy)this.start();
    else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error&&this.isConnected)this.start()});
  }
  disconnectedCallback(){document.removeEventListener('visitorConsentCollected',this.onConsent);this.controller?.abort()}
  async start(){
    if(this.started||!window.Shopify?.customerPrivacy?.preferencesProcessingAllowed())return;
    this.started=true;
    const key='marichyai-recent-products-v1';
    let history;
    try{
      const raw=JSON.parse(localStorage.getItem(key)||'[]');
      history=(Array.isArray(raw)?raw:[]).filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h));
      if(!window.Shopify.designMode)localStorage.setItem(key,JSON.stringify([this.dataset.current,...history.filter(h=>h!==this.dataset.current)].slice(0,12)));
    }catch{return}
    const handles=[...new Set(history)].filter(h=>h!==this.dataset.current).slice(0,Number(this.dataset.limit)||4);
    this.controller=new AbortController();
    const cards=await Promise.all(handles.map(async handle=>{
      try{
        const url=new URL(`${this.dataset.root}products/${handle}`,location.origin);url.searchParams.set('section_id',this.dataset.section);
        const response=await fetch(url,{signal:this.controller.signal});if(!response.ok)return null;
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const card=doc.querySelector('template[data-recent-card]')?.content.querySelector('li');
        if(!card?.querySelector('a[href*="/products/"]'))return null;
        card.querySelectorAll('script').forEach(n=>n.remove());
        card.querySelectorAll('[id]').forEach(n=>{n.id='recent-'+handle+'-'+n.id});
        card.querySelectorAll('[aria-labelledby]').forEach(n=>{n.setAttribute('aria-labelledby',n.getAttribute('aria-labelledby').split(' ').map(id=>'recent-'+handle+'-'+id).join(' '))});
        return card;
      }catch{return null}
    }));
    if(!this.isConnected)return;
    const available=cards.filter(Boolean);if(!available.length)return;
    this.querySelector('[data-recent-list]').replaceChildren(...available);this.querySelector('[data-recent-empty]')?.remove();this.hidden=false;
  }
});}

  } catch(e) { console.error(e); }
})();
})();
